module.exports = __webpack_public_path__ + "static/media/cross.217f8bd8.svg";